<template>
  <ul class="d-event__actions text-dark">
    <h3 class="marg-1-bottom" v-if="isPossibleToAdd">{{ $t('vue2.calendar_view_day.actions_for') }} "{{ event.title }}"
      {{ $t('vue2.calendar_view_day.onwards ') }}
    </h3>
    <li class="d-event__actions__action" :class="{'d-event__actions__action--open': getTheShowAction('remove')}">
      <h4 @click="setTheShowAction('remove')">
        {{ $t('vue2.calendar_view_day.remove_onwards') }}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="tw-icon w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
        </svg>
      </h4>
      <transition name="accordion"
                  @enter="start"
                  @after-enter="end"
                  @before-leave="start"
                  @after-leave="end">
        <div v-if="getTheShowAction('remove')">
          <p>{{ $t('vue2.calendar_view_day.do_you_want_to_remove') }} {{ calendar.name }} {{ $t('vue2.calendar_view_day.on_all') }} "{{ event.title }}"-{{ $t('vue2.calendar_view_day.lessons') }} {{ $t('vue2.calendar_view_day.onwards_which_include') }} {{ eventStartFormatted }} {{ $t('vue2.calendar_view_day.and_all_onwards') }}.</p>
          <button class="bttn bttn-danger" @click="openOnwardConfirm('remove')">{{ $t('vue2.calendar_view_day.remove') }}
            {{ calendar.name }} {{ $t('vue2.calendar_view_day.onwards') }}
          </button>
        </div>
      </transition>
    </li>
    <li class="d-event__actions__action" v-if="isPossibleToAdd" :class="{'d-event__actions__action--open': getTheShowAction('add')}">
      <h4 @click="setTheShowAction('add')">
        {{ $t('vue2.calendar_view_day.add_onwards') }}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="tw-icon w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
        </svg>
      </h4>
      <transition name="accordion"
                  @enter="start"
                  @after-enter="end"
                  @before-leave="start"
                  @after-leave="end">
        <div v-if="getTheShowAction('add')">
          <p>{{ $t('vue2.calendar_view_day.do_you_want_to_add') }} {{ calendar.name }} {{ $t('vue2.calendar_view_day.on_all') }} "{{ event.title }}"-{{ $t('vue2.calendar_view_day.lessons') }} {{ $t('vue2.calendar_view_day.onwards_which_include') }} {{ eventStartFormatted }} {{ $t('vue2.calendar_view_day.and_all_onwards') }}.</p>
          <button @click="openOnwardConfirm('add')">{{ $t('vue2.calendar_view_day.add') }} {{ calendar.name }}
            {{ $t('vue2.calendar_view_day.onwards') }}
          </button>
        </div>
      </transition>
    </li>
    <li class="d-event__actions__action" :class="{'d-event__actions__action--open': getTheShowAction('replace')}">
      <h4 @click="setTheShowAction('replace')">{{ $t('vue2.calendar_view_day.replace_onwards') }}
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="tw-icon w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
        </svg>
      </h4>
      <transition name="accordion"
                  @enter="start"
                  @after-enter="end"
                  @before-leave="start"
                  @after-leave="end">
        <div v-if="getTheShowAction('replace')">
          <p>{{ $t('vue2.calendar_view_day.select_the_person_to_replace') }} {{ calendar.name }} {{ $t('vue2.calendar_view_day.with_on_all') }} "{{ event.title }}"-{{ $t('vue2.calendar_view_day.lessons') }} {{ $t('vue2.calendar_view_day.onwards_which_include') }} {{ eventStartFormatted }} {{ $t('vue2.calendar_view_day.and_all_onwards') }}</p>
          <select v-model="theReplaceWithCalendarId">
            <option :value="null" disabled selected>{{ $t('vue2.calendar_view_day.select_person') }}..</option>
            <option v-for="cal in selectableCalendars" :value="cal.id" :key="cal.id">{{ cal.name }}</option>
          </select>
          <button v-show="theReplaceWithCalendarId && theReplaceWithCalendarId !== calendar.id" @click="openOnwardConfirm('replace')">{{ $t('vue2.calendar_view_day.replace') }} {{ calendar.name }} {{ $t('vue2.calendar_view_day.onwards') }}
          </button>
        </div>
      </transition>
    </li>
    <CalendarViewDayOnwardConfirm
      v-if="onwardConfirmMode"
      :mode="onwardConfirmMode"
      :calendarName="calendar.name"
      :minDate="eventStartDate"
      @close="onwardConfirmMode = null"
      @confirm="onOnwardConfirm">
    </CalendarViewDayOnwardConfirm>
  </ul>
</template>

<script>
import moment from 'moment'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import CalendarViewDayOnwardConfirm from './CalendarViewDayOnwardConfirm'

export default {
  components: {CalendarViewDayOnwardConfirm},
  props: {
    event: {
      default: null
    },
    calendar: {
      default: {
        id: 7,
        name: 'Henrik R.'
      }
    },
    calendars: {
      type: Array,
      default: () => []
    },
    isPossibleToAdd: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      theShowAction: null,
      theReplaceWithCalendarId: null,
      onwardConfirmMode: null
    }
  },
  computed: {
    selectableCalendars () {
      return this.calendars.filter(cal => cal.id !== this.calendar.id)
    },
    eventStartDate () {
      if (!this.event || !this.event.start) return moment().format('YYYY-MM-DD')
      return moment(this.event.start).format('YYYY-MM-DD')
    },
    eventStartFormatted () {
      if (!this.event || !this.event.start) return ''
      return moment(this.event.start).format('LL LT')
    }
  },
  methods: {
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    },
    setTheShowAction (action) {
      if (this.theShowAction === action) {
        this.theShowAction = null
      } else {
        this.theShowAction = action
      }
    },
    getTheShowAction (action) {
      return this.theShowAction === action
    },
    openOnwardConfirm (mode) {
      this.onwardConfirmMode = mode
    },
    onOnwardConfirm (enddate) {
      const mode = this.onwardConfirmMode
      this.onwardConfirmMode = null
      if (mode === 'remove') this.removeOnward(enddate)
      if (mode === 'add') this.addOnward(enddate)
      if (mode === 'replace') this.replaceOnward(enddate)
    },
    removeOnward (enddate) {
      docendo.eventRemoveCalendar(this.event.school_id, this.event.event_id, this.calendar.id, enddate || null, success => {
        eventbus.toast = {text: this.$t('vue2.substitution.lessons_updated'), 'success': true}
        this.$emit('updateAndClose')
      }, failure => {
        eventbus.toast = {text: 'Sorry, that failed', 'success': false}
        console.log('failure', failure)
      })
    },
    addOnward (enddate) {
      docendo.eventAddCalendar(this.event.school_id, this.event.event_id, this.calendar.id, enddate || null, success => {
        eventbus.toast = {text: this.$t('vue2.substitution.lessons_updated'), 'success': true}
        this.$emit('updateAndClose')
      }, failure => {
        eventbus.toast = {text: 'Sorry, that failed', 'success': false}
        console.log('failure', failure)
      })
    },
    replaceOnward (enddate) {
      docendo.eventReplaceCalendar(this.event.school_id, this.event.event_id, this.calendar.id, this.theReplaceWithCalendarId, enddate || null, success => {
        eventbus.toast = {text: this.$t('vue2.substitution.lessons_updated'), 'success': true}
        this.$emit('updateAndClose')
      }, failure => {
        eventbus.toast = {text: 'Sorry, that failed', 'success': false}
        console.log('failure', failure)
      })
    }
  }
}
</script>

<style scoped>

.d-event__actions {
  flex: 1;
  max-width: 300px;
  margin: 0;
  padding: 1rem;
  margin: 0 0 0 1rem;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.d-event__actions__action {
  position: relative;
  background: #ffffff;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
}

.d-event__actions__action div {
  overflow: hidden;
}

.d-event__actions__action:nth-child(2),
.d-event__actions__action:nth-child(2) h4 {
  border-radius: 4px 4px 0 0;
}

.d-event__actions__action:nth-child(2) {
  border-top: 1px solid #d9d9d9;
}

.d-event__actions__action:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #d9d9d9;
}

.d-event__actions__action h4 {
  position: relative;
  cursor: pointer;
  padding: 1rem;
  border-bottom: 1px solid #d9d9d9;
}

.d-event__actions__action h4:hover {
  background: aliceblue;
}

.d-event__actions__action h4 > svg {
  position: absolute;
  top: 1.15rem;
  right: 1rem;
  z-index: 2;
  transition: transform 0.5s;
}

.d-event__actions__action.d-event__actions__action--open h4 > svg {
  transform: rotate(-180deg);
}

.d-event__actions__action div > * {
  margin: 1rem;
}

.d-event__actions__action button,
.d-event__actions__action select {
  width: calc(100% - 2rem);
  height: auto;
  min-height: 28px;
}

.d-event__actions__action select {
  border-radius: 4px;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// CalendarViewDayRemoveOrReplace.vue?65fbe825